// GA4 event architecture. NEVER sends financial input values — only event names + safe metadata.
const GA_ID = process.env.REACT_APP_GA4_ID;

let _initialized = false;
// Loads the official gtag.js once, using the Measurement ID from env. No-op if unset.
export function initGA4() {
  if (_initialized || !GA_ID || typeof document === "undefined") return;
  _initialized = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false }); // we send page_view manually per SPA route
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
}

function push(event, params = {}) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag === "function") {
    window.gtag("event", event, params);
  } else {
    // Buffer for when GA loads / for debugging. No sensitive data included.
    window.dataLayer.push({ event, ...params });
  }
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.debug("[analytics]", event, params);
  }
}

export const analytics = {
  enabled: () => Boolean(GA_ID),
  pageView: (path, title) => push("page_view", { page_path: path, page_title: title }),
  calculatorView: (slug) => push("calculator_view", { calculator: slug }),
  calculatorStarted: (slug) => push("calculator_started", { calculator: slug }),
  calculatorCompleted: (slug) => push("calculator_completed", { calculator: slug }),
  calculatorReset: (slug) => push("calculator_reset", { calculator: slug }),
  productView: (id) => push("product_view", { product: id }),
  gumroadClick: (id) => push("gumroad_click", { product: id }),
  freeDownloadClick: (magnet) => push("free_download_click", { magnet }),
  emailSignup: (source) => push("email_signup", { source }),
  advisorRequest: (source, need, qualified) =>
    push("advisor_request", { source, need, qualified: qualified ? "qualified" : "unqualified" }),
  relatedClick: (slug) => push("related_tool_click", { target: slug }),
  mainSiteClick: (dest) => push("main_site_click", { destination: dest }),
  resultDownload: (slug, format) => push("result_download", { calculator: slug, format }),
};
